import React, { useState, useRef, useEffect } from "react";
import PropTypes from "prop-types";
import {
  DropdownWrapper,
  DropdownLabel,
  NewCustomDropdownContainer,
  CustomDropdownButton,
  CustomDropdownMenu,
  CustomDropdownOption,
  DropdownArrow,
} from "./Dropdown.styles";

export const DropdownNewCustom = ({
  title,
  options,
  value,
  onChange,
  name,
  disabled = false,
  placeholder = "Select an option",
  openUpward = false,
}) => {
  const [isOpen, setIsOpen] = useState(false);

  // Add/remove global class to hide slider knots when employment status dropdown is open
  useEffect(() => {
    // Only hide slider knots for employment status dropdown
    if (name && name.includes("current_employment_status")) {
      if (isOpen) {
        document.body.classList.add("dropdown-open");
      } else {
        document.body.classList.remove("dropdown-open");
      }
    }

    // Cleanup on unmount
    return () => {
      if (name && name.includes("current_employment_status")) {
        document.body.classList.remove("dropdown-open");
      }
    };
  }, [isOpen, name]);
  const [selectedOption, setSelectedOption] = useState(
    options.find((option) => option.value === value) || null
  );
  const dropdownRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  useEffect(() => {
    const newSelectedOption = options.find((option) => option.value === value);
    setSelectedOption(newSelectedOption || null);
  }, [value, options]);

  const handleOptionClick = (option) => {
    setSelectedOption(option);
    onChange(option.value);
    setIsOpen(false);
  };

  const toggleDropdown = () => {
    if (!disabled) {
      setIsOpen(!isOpen);
    }
  };

  return (
    <DropdownWrapper ref={dropdownRef}>
      {title && <DropdownLabel>{title}</DropdownLabel>}
      <NewCustomDropdownContainer>
        <CustomDropdownButton
          onClick={toggleDropdown}
          disabled={disabled}
          $isOpen={isOpen}
          $hasValue={!!selectedOption}
        >
          <span className="dropdown-text">
            {selectedOption ? selectedOption.label : placeholder}
          </span>
          <DropdownArrow $isOpen={isOpen} />
        </CustomDropdownButton>

        {isOpen && (
          <CustomDropdownMenu $openUpward={openUpward}>
            {options.map((option) => (
              <CustomDropdownOption
                key={option.value}
                onClick={() => handleOptionClick(option)}
                $isSelected={selectedOption?.value === option.value}
              >
                <span className="option-text">{option.label}</span>
                {selectedOption?.value === option.value && (
                  <span className="checkmark">✓</span>
                )}
              </CustomDropdownOption>
            ))}
          </CustomDropdownMenu>
        )}
      </NewCustomDropdownContainer>

      {/* Hidden input for form compatibility */}
      <input type="hidden" name={name} value={selectedOption?.value || ""} />
    </DropdownWrapper>
  );
};

DropdownNewCustom.propTypes = {
  title: PropTypes.string,
  options: PropTypes.arrayOf(
    PropTypes.shape({
      value: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
        .isRequired,
      label: PropTypes.string.isRequired,
    })
  ).isRequired,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  onChange: PropTypes.func.isRequired,
  name: PropTypes.string,
  disabled: PropTypes.bool,
  placeholder: PropTypes.string,
  openUpward: PropTypes.bool,
};
